import { X } from "lucide-react";
import { useEffect, useState } from "react";
import type { RequireLoginModalProps } from "../core/types/tsx/components/RequireLoginModal.types";


export function RequireLoginModal({ isOpen, onClose, onConfirm }: RequireLoginModalProps) {
  const [isRendered, setIsRendered] = useState(isOpen);
  const [isActive, setIsActive] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setIsRendered(true);
      const raf = requestAnimationFrame(() => setIsActive(true));
      return () => cancelAnimationFrame(raf);
    }

    setIsActive(false);
    const timeoutId = window.setTimeout(() => setIsRendered(false), 200);
    return () => window.clearTimeout(timeoutId);
  }, [isOpen]);

  if (!isRendered) return null;

  return (
    <div
      className={
        "fixed inset-0 z-50 flex items-center justify-center px-4 transition-opacity duration-200 " +
        (isActive ? "bg-black/50 opacity-100" : "bg-black/0 opacity-0")
      }
      role="dialog"
      aria-modal="true"
      aria-labelledby="require-login-title"
    >
      <div
        className={
          "relative w-full max-w-md transform rounded-2xl bg-white p-6 shadow-2xl transition-all duration-200 sm:p-8 " +
          (isActive ? "translate-y-0 scale-100 opacity-100" : "translate-y-2 scale-95 opacity-0")
        }
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Cerrar"
          className="absolute right-4 top-4 rounded-full p-1 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="flex flex-col gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Requiere sesion</p>
            <h2 id="require-login-title" className="mt-2 text-xl font-semibold text-slate-900">
              Inicia sesion para solicitar un servicio
            </h2>
            <p className="mt-3 text-sm text-slate-600">
              Para continuar con tu solicitud necesitas iniciar sesion en Servix.
            </p>
          </div>

           <button
            type="button"
            onClick={onConfirm}
            className="w-full rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-primary-hover"
          >
            Iniciar sesion
          </button>
        </div>
      </div>
    </div>
  );
}
